<template>
  <div class="patient-records big">
    <div
      class="flex between"
      style="padding-right:20px"
    >
      <div class="page_title">患者病历病程</div>
      <el-button
        type="primary"
        @click="back"
        style="width:120px"
      >返回</el-button>
    </div>

    <div style="padding:20px;">
      <div class="container">
        <!-- 信息 -->
        <info
          :doctorInfo="doctor_info"
          :userInfo="patient_info"
        ></info>

        <div style="border: solid 1px #c9cbd6">
          <el-table
            v-loading="tableLoading"
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >

            <el-table-column
              v-for="(item,index) in tableHeader"
              :key="index"
              :label="item.label"
              :prop="item.prop"
              :width="item.width"
              :align="item.align"
            >
            </el-table-column>

            <el-table-column
              label="操作"
              width="220"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="lookInquiry(scope.row)"
                  :disabled="module_id_array[0]? !module_id_array.includes('634'): false"
                >查看病历</el-button>
                <el-button
                  type="text"
                  @click="lookAbstract(scope.row)"
                  :disabled="module_id_array[0]? !module_id_array.includes('634'): false"
                >病历摘要</el-button>
              </template>
            </el-table-column>

          </el-table>
        </div>

        <div class="footer-pagination">
          <pagination
            v-show="totalNum>0"
            :total="totalNum"
            :page.sync="pagination.page"
            :limit.sync="pagination.pageNumber"
            @pagination="searchList"
          />
        </div>

      </div>
    </div>
    <!-- 查看 -->
    <inquiry-tem
      v-if="isLook"
      :consult_inquiry_id="consult_inquiry_id"
      @close="isLook = false"
    ></inquiry-tem>

    <!-- 病历摘要 -->
    <el-dialog
      title="患者病历摘要"
      :visible.sync="abstractDia"
      width="600px"
      :close-on-click-modal="false"
    >
      <div
        class="abstractDiaDialog"
        v-html="this.content_desc"
      >
      </div>
      <div style="text-align: center; padding-bottom: 20px">
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            plain
            @click="abstractDia = false"
            size="medium"
          >关闭</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import message from '../../../../api/message';
import Pagination from '@/components/Pagination';
import Info from '../components/Info';
import InquiryTem from '../components/inquiryTem.vue';
export default {
  components: {
    Pagination,
    Info,
    InquiryTem
  },
  data() {
    return {
      isLook: false,
      abstractDia: false,
      consult_inquiry_id: '',
      content_desc: '',
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10
      },
      doctor_info: {},
      patient_info: {},
      tableHeader: [
        {
          label: '病历创建时间',
          prop: 'create_time',
          width: '200',
          align: 'left'
        },
        {
          label: '问诊单模板名称',
          prop: 'inquiry_sheet_name',
          width: 'auto',
          align: 'left'
        }
      ],
      tableData: []
    };
  },
  filters: {},
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    routerData() {
      return this.$route.query;
    }
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.tableLoading = true;
      message.getInquiryPatientDetail(this.routerData).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.patient_info = data.patient_info;
          this.doctor_info = data.doctor_info;
          this.tableData = data.list;
          this.tableLoading = false;
        }
      });
    },
    lookInquiry(row) {
      this.consult_inquiry_id = row.consult_inquiry_id;
      this.isLook = true;
    },
    lookAbstract(row) {
      this.abstractDia = true;
      this.axios
        .post('platform/Inquirysheet/getConsultInquiryContentInfo', {
          consult_inquiry_id: row.consult_inquiry_id
        })
        .then((res) => {
          if (res.code == 0) {
            this.content_desc = res.data.info.content_desc;
          }
        });
    },
    searchList() {},
    back() {
      history.back();
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  position: relative;
}
.abstractDiaDialog {
  padding: 20px;
  text-align: left;
}
// .patient-records {
// }
</style>